import { hasLimits } from "@/utils/permission";
import { localCache } from "@/utils/Cache";
const menuList = {
  state: {
    imgUrl: `http://cqusms.cqu.edu.cn/`,
    scrollTop: 0,
    funcList: [
      {
        clientName: "场地预约",
        clientUrl: "http://192.168.0.53:443",
        name: "venueReservation",
        color: "#E2F7F4",
        permission: "/venueReservation",
        show: true,
        iconShow: true,
      },
      {
        clientName: "工位系统",
        clientUrl: "http://192.168.0.53:9112",
        name: "eventReservation",
        color: "#E2F7F4",
        permission: "/eventReservation",
        show: true,
        iconShow: true,
      },
      {
        clientName: "考勤打卡",
        clientUrl: "http://192.168.0.53:9114",
        name: "joinActivities",
        color: "#E2F7F4",
        permission: "/joinActivities",
        show: true,
        iconShow: true,
      },
      {
        clientName: "校友会",
        clientUrl: "http://192.168.0.53:9101",
        name: "taskList",
        color: "#E2F7F4",
        permission: "/taskList",
        show: true,
        iconShow: true,
      },
    ],
    ownUrl: "https://www.mingxiaobang.cn/mobile/sccpPlatform/",
    // ownUrl: "http://192.168.0.53:9110",
  },
  actions: {},
  mutations: {
    setScrollTop(state, n) {
      state.scrollTop = n;
    },
    setMenu(state) {
      const permissionList =
        localCache.getCache("permissionList") &&
        JSON.parse(localCache.getCache("permissionList"));
      if (permissionList?.length) {
        state.funcList?.forEach((item) => {
          if (
            item.path == "/signQRCode" &&
            permissionList?.includes(item.permission)
          ) {
            item.show = true;
          }
          if (
            item.path == "/signOutQRCode" &&
            permissionList?.includes(item.permission)
          ) {
            item.show = true;
          }
        });
      }
    },
  },
};

export default menuList;

